import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function LoginPage() {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate('/orders', { replace: true })
    }
  }, [isAuthenticated, isLoading, navigate])

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f4f6f9',
    }}>
      <div className="card" style={{ width: 360, textAlign: 'center' }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>📦</div>
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>
          Intranet
        </h1>
        <p style={{ color: 'var(--color-muted)', marginBottom: 24, fontSize: 14 }}>
          Auftragsverwaltung
        </p>
        <button
          className="btn btn-primary"
          style={{ width: '100%', justifyContent: 'center', padding: '10px 0' }}
          onClick={() => loginWithRedirect()}
          disabled={isLoading}
        >
          {isLoading ? 'Laden…' : 'Anmelden'}
        </button>
      </div>
    </div>
  )
}
